<template>
  <div class="mg-box box-sizing">
    <div class="header"><el-button type="primary" size="mini" @click="$router.back()">返回</el-button></div>
    <div class="left">
      <div class="qr-code" ref="urlQrCode"></div>
      <div class="download-btn"><el-button class="btn" type="primary" @click="savePic">下载二维码</el-button></div>
    </div>
    <div class="right">
      <div class="item">
        <span class="lab">备注名称：</span>
        <span class="inp">
                    <el-input placeholder="请输入备注" v-model="urlInfo.mark" clearable></el-input>
                </span>
      </div>
      <div class="item">
        <span class="lab">原网址：</span>
        <span class="inp">
                    <el-input v-model="urlInfo.url" clearable :readonly="!isVip" @focus="showVipPop"></el-input>
                </span>
      </div>
      <div class="item">
        <span class="lab">短网址：</span>
        <span class="inp">{{urlInfo.new_url}}
                <el-link type="primary" @click="showReplaceUrl">修改</el-link>
                </span>

      </div>
      <div class="item">
        <span class="lab">创建时间：</span>
        <span class="inp">{{urlInfo.create_time*1000 | dateFormat}}</span>
      </div>
      <div class="item">
        <span class="lab">微信提示浏览器打开：</span>
        <span class="inp">
                    <el-switch v-model="urlInfo.open_tips" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="showVipPop"></el-switch>
                </span>

      </div>
      <div class="item">
        <span class="lab">只允许在微信打开：</span>
        <span class="inp">
                    <el-switch v-model="urlInfo.just_weixin_open" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="showVipPop"></el-switch>
                </span>

      </div>


      <div style="color:red;font-size: 12px;margin-left:190px;">* 以下如果你的链接在微信是红标或需要直接下载，<br>此功能可以直接在微信里自动使用浏览器打开，目前只支持安卓，打开成功率大概为50%</div>
      <div class="item">
        <span class="lab">微信强制打开浏览器：</span>
        <span class="inp">
                    <el-switch v-model="urlInfo.open_red" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="showVipPop"></el-switch>
                </span>

      </div>


      <div class="item">
        <span class="lab">QQ提示浏览器打开：</span>
        <span class="inp">
                    <el-switch v-model="urlInfo.qq_open_tips" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="showVipPop"></el-switch>
                </span>

      </div>

      <div class="item">
        <span class="lab">密码访问：</span>
        <span class="inp">
                    <el-switch v-model="urlInfo.is_pass" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="showVipPop"></el-switch>
                </span>
      </div>
      <div class="item">
        <span class="lab">设置密码：</span>
        <span class="inp">
                    <el-input placeholder="请输入6位数字密码" v-model="urlInfo.passwd" show-password maxlength="6" @focus="showVipPop"></el-input>
                </span>
      </div>
      <div class="item" style="height:auto;">
        <span class="lab">ip黑名单：</span>
        <span class="inp" style="height:auto;">
              <textarea  placeholder="一行一个,如 28.38.492.2" style="height:200px;width:100%;border:1px solid #ddd;" v-model="urlInfo.black_ip" clearable></textarea>
                </span>
      </div>

      <div class="item">
        <span class="lab">黑名单跳转地址：</span>
        <span class="inp">
                    <el-input v-model="urlInfo.black_url" clearable :readonly="!isVip" @focus="showVipPop"></el-input>
                </span>
      </div>

      <div class="item" style="height:auto;">
        <span class="lab">失效时间：</span>
        <span class="inp" style="height:auto;">
              <el-date-picker v-model="urlInfo.expire_time" type="datetime" placeholder="选择时间" @change="dataSearch" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"></el-date-picker>

             </span>
      </div>
      <div class="item" style="height:auto;">
        <span class="lab">IP限制访问次数：</span>
        <span class="inp" style="height:auto;">
              <el-input placeholder="填写数字" v-model="urlInfo.ip_limit_pv"  @focus="showVipPop"></el-input>
                    <div class="fs12">如果超出这个次数，对应IP的访问会显示 "404访问受限"</div>

             </span>
      </div>
      <div class="item" style="height:auto;">
        <span class="lab">总限制访问次数：</span>
        <span class="inp" style="height:auto;">
              <el-input placeholder="填写数字" v-model="urlInfo.limit_pv"  @focus="showVipPop"></el-input>
                    <div class="fs12">如果超出这个次数，链接所有访问都显示 "404访问受限"</div>

             </span>
      </div>
      <div class="item" style="height:auto;">
        <span class="lab">限制提示：</span>
        <span class="inp" style="height:auto;">
              <el-input placeholder="填写提示文字" v-model="urlInfo.limit_pv_tips"  @focus="showVipPop"></el-input>
                    <div class="fs12">默认提示“访问受限”</div>

             </span>
      </div>
      <div class="item">
        <span class="lab"></span>
        <span class="inp">
                    <el-button type="primary" :loading="isLoading1" @click="saveEdit">保存</el-button>
                    <el-button type="danger" :loading="isLoading2" @click="delUrl">删除</el-button>
                </span>
      </div>
    </div>
    <div class="mask" v-show="isShowVipPop"></div>
    <div class="vip-pop" v-show="isShowVipPop">
      <div class="close-btn" @click="isShowVipPop=false"><i class="el-icon-circle-close"></i></div>
      <div class="people"><img src="../../assets/images/people.png" alt="升级VIP"></div>
      <div class="banner"><img src="../../assets/images/bgvip.png" alt="升级VIP"></div>
      <div class="wd50"></div>
      <div class="square-box">
        <span><div class="title">防止劫持</div><img src="../../assets/images/safe.png" alt="防止劫持"><p class="content">银行级别加密</p></span>
        <span><div class="title">无需审核</div><img src="../../assets/images/check.png" alt="无需审核"><p class="content">是链接就能转</p></span>
        <span><div class="title">专属报表</div><img src="../../assets/images/report.png" alt="专属报表"><p class="content">保留30天数据</p></span>
        <span><div class="title">替换功能</div><img src="../../assets/images/replace.png" alt="替换功能"><p class="content">可替换原网址</p></span>
        <span><div class="title">渠道管理</div><img src="../../assets/images/channel.png" alt="渠道管理"><p class="content">生成多个链接</p></span>
        <span><div class="title">高级功能</div><img src="../../assets/images/advanced.png" alt="高级功能"><p class="content">设备地区指向</p></span>
      </div>
      <div class="wd40"></div>
      <div class="more-message"><router-link to="/tabs/vipContrast">了解更多详情></router-link></div>
      <div class="wd40"></div>
      <div class="btn-box">
        <router-link to="/tabs/vipRecharge">立即升级VIP</router-link>
      </div>
    </div>
    <el-dialog title="短网址后缀替换" :visible.sync="replaceDialog" center width="400px">
            <span class="replace" style="font-size: 16px;">
                <div class="item">
                    <div class="l">原短链接：</div>
                    <div class="r"><el-input v-model="urlInfo.new_url" readonly placeholder="原链接" style="font-size:24px;" ></el-input></div>
                </div>
                <div class="item"></div>
                <div class="item" style="margin-top: 15px;">
                    <div class="l">新的短链接：</div>
                    <div class="r"  style="font-size:24px;text-indent: 16px;" >http://{{urlInfo.domain}}/<el-input style="width:150px;font-size:18px;" v-model="newUrl" clearable placeholder="后缀"></el-input></div>
                </div>


            </span>
      <div style="color:red;padding:20px;">
        注意：<br>
        1. 修改之后二维码需要重新获取。 <br>
        2. 本功能只支持专属域名。 <br>
        3. 可输入1-10个字符,字符为数字或字母

      </div>
      <span slot="footer">
                <el-button @click="replaceDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading5" @click="replaceUrl">确定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  name: "manage",
  data() {
    return{
      id: 0,
      isVip: false,
      isLoading1: false,
      isLoading2: false,
      isShowVipPop: false,
      isLoading_fix:false,
      replaceDialog:false,
      urlInfo: {},
      newUrl:'',
    };
  },
  mounted() {
    const times = Date.parse(new Date())/1000;
    const user_info = this.$storeLocal.get('userInfo');
    this.id = this.$route.params.id;
    setTimeout(this.getLinkInfo,200);
    if (user_info.expire_date > times){
      this.isVip = true;
    }
  },
  methods: {
    async getLinkInfo() {
      const {ret,data} = await this.$api.shortUrl.getLinkInfo({id:this.id});
      if (ret === 1000){
        this.urlInfo = data;
        setTimeout(this.bindQRCode,200);
      }else {
        this.$router.back();
      }
    },
    showReplaceUrl() {
      if (this.urlInfo.is_exclusive) {
        this.replaceDialog = true;
      } else {
        this.$confirm('该功能为专属域名功能，请购买专属域名后使用', '提示', {
          confirmButtonText: '前往购买',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$router.push('/tabs/buyDomain');
        });
      }
    },
    async replaceUrl() {
      const newUrl = this.newUrl;
      const postData = {
        id: this.id,
        newUrl: newUrl,
      };
      this.isLoading_fix = true;
      const {ret} = await this.$api.shortUrl.replaceUrlFix(postData);
      this.isLoading_fix = false;
      if (ret === 1000) {
        this.replaceDialog = false;
        this.$message.success('替换成功！');
        await this.getLinkInfo();
      }
    },
    async saveEdit() {
      const reg = new RegExp("^[0-9]{6}$");
      const {id,mark,url,is_pass,open_red,passwd,open_tips,qq_open_tips,just_weixin_open,black_ip,black_url,expire_time,ip_limit_pv,limit_pv,limit_pv_tips} = this.urlInfo;
      if (!this.$common.isUrl(url)){
        //this.$message.error('请输入正确的原网址！');
        //return;

      }
      if (passwd && !reg.test(passwd)){
        this.$message.error('密码需为6位纯数字！');
        return;
      }
      const postData = {
        id: id,
        mark: mark,
        url: url,
        isPass: is_pass,
        open_red:open_red,
        open_tips:open_tips,
        qq_open_tips:qq_open_tips,
        just_weixin_open:just_weixin_open,
        passwd: passwd,
        black_ip:black_ip,
        black_url:black_url,
        ip_limit_pv:ip_limit_pv,
        limit_pv:limit_pv,
        limit_pv_tips:limit_pv_tips,
        expire_time:expire_time
      };
      this.isLoading1 = true;
      const {ret} = await this.$api.shortUrl.editLink(postData);
      this.isLoading1 = false;
      if (ret === 1000){
        this.$message.success('保存成功');
      }
    },
    delUrl() {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( async () => {
        this.isLoading2 = true;
        const {ret} = await this.$api.shortUrl.delLink({ids:this.id});
        this.isLoading2 = false;
        if (ret === 1000){
          this.$message.success('删除成功');
          this.$router.back();
        }
      });
    },
    showVipPop() {
      if (!this.isVip){
        if (!this.urlInfo.is_exclusive){
          this.isShowVipPop = true;
          this.urlInfo.is_pass = 0;
          this.urlInfo.open_red = 0;
          this.urlInfo.open_tips = 0;
          this.urlInfo.just_weixin_open = 0;
        }
      }
    },
    bindQRCode() {
      const txt = this.urlInfo.new_url;
      if (txt === '') return;
      this.$refs.urlQrCode.innerHTML = '';
      new QRCode(this.$refs.urlQrCode, {
        text: txt,
        width: 160,
        height: 160,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    savePic() {
      let myQrCode = this.$refs.urlQrCode.getElementsByTagName('canvas');
      let a = document.createElement('a');
      a.href = myQrCode[0].toDataURL('image/png');
      a.download = this.urlInfo.new_url;
      a.click();
    },
  }
}
</script>

<style scoped>
.mg-box{
  width: 100%;
  height: auto;
  padding: 20px;
}
.mg-box .header{
  width: 100%;
  height: 40px;
  text-align: right;
}
.mg-box .left{
  display: inline-block;
  width: 340px;
  height: auto;
  margin-top: 100px;
  vertical-align: top;
}
.mg-box .right{
  display: inline-block;
  width: 800px;
  height: auto;
  padding-top: 100px;
  vertical-align: top;
}
.mg-box .left .qr-code{
  width: 160px;
  height: 160px;
  margin-left: 160px;
}
.mg-box .left .download-btn{
  width: 160px;
  height: 40px;
  margin-top: 10px;
  margin-left: 160px;
}
.mg-box .left .download-btn .btn{
  width: 100%;
}
.mg-box .right .item{
  width: 500px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
}
.mg-box .right .item .lab{
  display: inline-block;
  width: 190px;
  height: 40px;
  color: #999999;
  text-align: right;
  margin-right: 10px;
  vertical-align: top;
}
.mg-box .right .item .inp{
  display: inline-block;
  width: 300px;
  height: 40px;
  vertical-align: top;
}
</style>
